import { ArticleTechnicalInfoVO } from '../model/vo/article.vo';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface ArticleTechnicalInfoNotification {
  success: boolean,
  technicalInfo?: ArticleTechnicalInfoVO[],
  error?: any
}

@Injectable({ providedIn: 'root' })
export class ArticleTechnicalInfoService {

  private articleTechnicalInfoSubject: Subject<ArticleTechnicalInfoNotification> = new Subject<ArticleTechnicalInfoNotification>();
  public get articleTechnicalInfo$(): Observable<ArticleTechnicalInfoNotification> {
    return this.articleTechnicalInfoSubject.asObservable();
  }

  public notifyArticleTechnicalInfoLoadedSuccess(technicalInfo: ArticleTechnicalInfoVO[]): void {
    const notification: ArticleTechnicalInfoNotification = {
      success: true,
      technicalInfo: technicalInfo
    };
    this.articleTechnicalInfoSubject.next(notification);
  }

  public notifyArticleTechnicalInfoLoadedFailure(error:any): void {
    const notification: ArticleTechnicalInfoNotification = {
      success: false,
      error: error
    };
    this.articleTechnicalInfoSubject.next(notification);
  }
}
